<template>
  <div style="overflow: scroll">
    <div class="base-info">
      <!-- {{ hospitalInfo.hospitalName }} -->
      <div @click="showPicker = true" class="inspection-name">
        <div class="van-ellipsis" style="width: 90%;">
          {{ currentItem.title }}
        </div>
        <van-icon name="arrow-down" color="white" />
      </div>
      <div style="display: flex;">
        <span>{{ userInfo.name }} {{ userInfo.cardNo }}</span>
        <!-- <span style="margin-left: auto;">{{
          date.replace(/(.{2})(.{2})/, "$1月$2日")
        }}</span> -->
      </div>
      样本：{{ userInfo.sample }}
    </div>
    <div
      v-for="(item, index) in inspectionDetailList"
      :key="index"
      class="item-list"
    >
      <!-- <div
        :class="[
          item.departure == 1 ? 'item-value-up' : '',
          item.departure == -1 ? 'item-value-down' : ''
        ]"
      >
        {{ item.name }}
        <span>
          {{ item.value }}
          <span
            v-if="item.departure == 1"
            style="margin-left: 6px;font-size: 1rem"
            >↑</span
          >
          <span
            v-if="item.departure == -1"
            style="margin-left: 6px;font-size: 1rem"
            >↓</span
          >
        </span>
      </div> -->
      <div style="padding: 1rem 0;font-size: .94rem">
        <div>{{ item.projectName }}</div>
        <div style="margin-top:.5rem">报告时间：{{ item.reportTime }}</div>
        <div style="margin-top:.5rem">参考值： {{ item.referenceRange }}</div>
        <div style="margin-top:.5rem">结果： {{ item.inspectionResult }}</div>
        <!-- <span style="margin-left: auto;">单位：{{ item.unit }}</span> -->
      </div>
    </div>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        :columns="getReportList"
        @cancel="showPicker = false"
        @confirm="onConfirm"
        show-toolbar
      />
    </van-popup>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      inspectionDetailList: [],
      query: {},
      currentItem: {},
      list: [],
      userInfo: {},
      showPicker: false,
      date: ""
    };
  },
  computed: {
    // ...mapState({
    //   hospitalInfo: state => state.home.hospitalInfo
    // }),
    getReportList() {
      return this.list.map(item => {
        return {
          text: item.title,
          ...item
        };
      });
    }
  },
  created() {
    const { currentItem, list, date } = this.$route.query;
    this.currentItem = currentItem;
    this.list = list;
    this.date = date;
    this.getInspectionsDetail(currentItem);
    // this.$http
    //   .post(this.$api.TEST_GET_BASEINFO, {
    //     hospitalId: "350802",
    //     cardtype: "1",
    //     cardNo: this.$route.query.cardNo
    //   })
    //   .then(res => {
    //     this.userInfo = res;
    //   });
  },
  methods: {
    ...mapActions("users", ["getUserBaseInfo"]),
    onConfirm(item) {
      this.showPicker = false;
      this.currentItem = item;
      this.getInspectionsDetail(item);
    },
    getInspectionsDetail(param) {
      console.log(param);
      this.$http
        .post(this.$api.TEST_GET_REPORT_DETAIL, {
          jydh: param.id,
          inspectionType: param.inspectionType,
          hospitalId: "350802"
        })
        .then(res => {
          this.inspectionDetailList = res;
          this.userInfo = res[0];
        });
    }
  }
};
</script>

<style lang="less" scoped>
.base-info {
  padding: 10px;
  color: white;
  background: @primary-blue;
}
.inspection-name {
  display: flex;
  margin: 4px 0;
  color: white;
  span {
    font-size: 0.94rem;
  }
}

.item-list {
  margin: 12px;
  padding-bottom: 12px;
  border-bottom: solid 0.67px #dcdcdc;

  div {
    line-height: 1.5rem;
    text-align: left;
  }

  span {
    color: #959595;
    font-size: 0.88rem;
  }
}

.item-value-up {
  justify-content: space-between;
  color: red;
  span {
    color: red;
  }
}

.item-value-down {
  color: blue;

  span {
    color: blue;
  }
}
</style>
